import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from '../components/Spinner';
import { TranslationSection, loadTranslationSections, sectionsLoaded } from '../i18nconfig';

// Loads big translation sections (the blog, printing guides, legal pages, shop locations) for the current language
// and says when they're ready, so they stay out of the main bundle
export const useTranslationSections = (sections: TranslationSection[]) => {
  const { i18n } = useTranslation();
  const key = sections.join(',');
  const [ready, setReady] = useState(() => sectionsLoaded(i18n.language, sections));

  useEffect(() => {
    let active = true;
    setReady(sectionsLoaded(i18n.language, sections));
    loadTranslationSections(i18n.language, sections)
      .then(() => active && setReady(true))
      .catch((error) => console.error('Failed to load translations', error));
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, key]);

  return ready;
};

// A route whose page needs some sections: a spinner until they're loaded
export const WithTranslationSections: React.FC<{ sections: TranslationSection[]; children: React.ReactNode }> = ({
  sections,
  children,
}) => (useTranslationSections(sections) ? <>{children}</> : <Spinner />);
